module.exports = __webpack_public_path__ + "files/e11e36fc9cb7df09b89afe8a22298976.png";